import { CalendarDays } from "lucide-react";
import { useTranslation } from "react-i18next";

export function ScheduleEmptyState() {
  const [translate] = useTranslation(["insights"]);

  return (
    <div className="flex flex-col flex-1 gap-3 justify-center items-center p-8 text-center bg-white rounded-xl border border-secondary-200">
      <div className="flex justify-center items-center w-14 h-14 rounded-xl bg-tertiary-200">
        <CalendarDays className="w-6 h-6 text-neutral-500" />
      </div>
      <div className="flex flex-col gap-1">
        <p className="text-base font-bold">
          {translate("schedule-empty-title")}
        </p>
        <p className="text-sm text-neutral-500">
          {translate("schedule-empty-description")}
        </p>
      </div>
    </div>
  );
}
